import React, { useState } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { handleActiveSelect } from '../../../features/layout/layoutSlice'
import Button from "../../shared/button/Btn"
import { showModal } from '../../../features/modal/modalSlice'
import { createSavedEArsivCustomer, getMernisDataEArsiv } from '../../../features/e-Arsiv/eArsivSlice'
import InputText from '../../shared/input/new/InputText'
import PageTopTitle from '../../shared/PageTopTitle'
import InputNumberWithSuffix from '../../shared/input/new/InputNumberWithSuffix'

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 600px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            margin-block: 20px;
            padding: 0 40px;
            display: flex;
            width: 100%;
            flex-direction: column;
            align-items: center;
            height: 100%;
            gap: 30px;
            .inputs{
                margin-top: 20px;
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 15px;
                .row{
                    width: 100%;
                }
            }
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            /* margin-bottom: 40px; */
            gap: 15px;
        }
    }
    .flex{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
    }
`

const EArsivKayitliMusteriEkleModal = () => {
    const {theme} = useSelector((state)=> state.layout)
    const {mernisDataEArsiv} = useSelector((state)=> state.eArsiv)
    const dispatch = useDispatch()

    const gibCallId = JSON.parse(localStorage.getItem("gibCallId"))
    const gibCallIdCount = JSON.parse(localStorage.getItem("gibCallIdCount"))
    const gibToken = JSON.parse(localStorage.getItem("gibToken"))
    const [data, setData] = useState({
        vknTcKn: "",
        name: "",
        surname: "",
        title: "",
        taxOffice: "",
    })

    const handleChange = (e) => {
        setData((prev) => ({...prev, [e.target.name]: e.target.value}))
    }

    const handleSubmit = () => {
       dispatch(createSavedEArsivCustomer(
        {
            vknTcKn: data?.vknTcKn,
            name: mernisDataEArsiv?.name,
            surname: mernisDataEArsiv?.surname,
            title: mernisDataEArsiv?.title,
            taxOffice: mernisDataEArsiv?.taxOffice,
        }
       ))
    }

  return (
    <ModalContainer onClick={(e) => { e.stopPropagation(); dispatch(handleActiveSelect(null)); }}>
        <div className='modal'>
        <PageTopTitle title={"Kayıtlı Müşteriler"} position='sticky' top='210px'/>

            <div className="content">

                <div className="inputs">
                    <div className="row flex">
                        <InputNumberWithSuffix noneSeperator data={data?.vknTcKn} setData={(e) => handleChange(e)} inputWidth={"100%"} labelText={"Vergi / Tc No"} name={"vknTcKn"} />
                        <Button handleClick={() => dispatch(getMernisDataEArsiv(data?.vknTcKn))} bgColor='transparent' color='#E85446' padding='0px 10px' >Sorgula</Button>
                    </div>
                    <div className="row">
                        <InputText disabled data={mernisDataEArsiv?.taxOffice} setData={(e) => handleChange(e)} inputWidth={"100%"} labelText={"Vergi Dairesi"} name={"taxOffice"}  />
                    </div>
                    <div className="row">
                        <InputText disabled data={mernisDataEArsiv?.name} setData={(e) => handleChange(e)} inputWidth={"100%"} labelText={"Ad"} name={"name"} />
                    </div>
                    <div className="row">
                        <InputText disabled data={mernisDataEArsiv?.surname} setData={(e) => handleChange(e)} inputWidth={"100%"} labelText={"Soyad"} name={"surname"} />
                    </div>
                    <div className="row">
                        <InputText disabled data={mernisDataEArsiv?.title} setData={(e) => handleChange(e)} inputWidth={"100%"} labelText={"Ünvan"} name={"title"} />
                    </div>
                </div>

                <div className="button-grp">
                    <Button width="150px" color="#E85446" padding="10px" handleClick={handleSubmit} >Ekle</Button>
                    <Button handleClick={()=>dispatch(showModal(null))} width="150px" color="#E85446" padding="10px">Kapat</Button>
                </div>
            </div>
        </div>
    </ModalContainer>
  )
}

export default EArsivKayitliMusteriEkleModal